module.exports = "/remote-dist/71b0dce9a0f78e83ffd60b1754ffff4a.png";